export default __webpack_public_path__ + "hero-next-768-3f845383c9aa0c71d0fb76cbdfd2b9f1.bundle.png";